import {receptionistDeviceTypes} from "./type";
import {BaseReducer} from "../../reducers/base";

const types = receptionistDeviceTypes;

const initialState = {
    datas: [],
    data: {},
    isLoading: false,
    success: false,
    msg: {},
};

const receptionistDeviceReducer = (state = initialState, action) => {
    const baseClass = new BaseReducer(types, state, action);

    return baseClass.baseReducer();
};

export default receptionistDeviceReducer;
